import { render, staticRenderFns } from "./BackHome.vue?vue&type=template&id=1bf49c56&scoped=true"
import script from "./BackHome.vue?vue&type=script&lang=js"
export * from "./BackHome.vue?vue&type=script&lang=js"
import style0 from "./BackHome.vue?vue&type=style&index=0&id=1bf49c56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf49c56",
  null
  
)

export default component.exports